import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { CardLayout } from "../../../../Shared/components/CardLayout/CardLayout";
import { ToggleCard } from "../../../../Shared/components/ToggleCard/ToggleCard";
import { MealSizeText } from "./MealSizeModule-Types";
import { useMealSize } from "./useMealSize";
import { tokenReplace } from "../../../../Shared/utils/tokenReplacement";
import { useCompanyConfigQuery } from "../../../../SWR/Company/useCompanyConfigQuery";
/**
 * MealSize - Renders the MealSize module: A list of meal size buttons in either a grid or slider.
 * @param componentSequence: used to identify specific module when more than one of the same kind is used in the flow builder
 * @returns MealSize Module
 */
export const MealSize = ({ sequenceNumber }) => {
    const { handleMealSizeChange, mealSizesToRender, mealSizeCardLayoutSettings, MealSizes, storeCartMealSize, MealSizeDisplayMode, CardDescriptionLines, showDescription, } = useMealSize(sequenceNumber);
    const { tokenMap } = useCompanyConfigQuery();
    const mealSizeChangeWarningTitle = tokenReplace(MealSizeText.MEAL_SIZE_CHANGE_WARNING, true, tokenMap);
    const mealSizeChangeWarningTextDefault = tokenReplace(MealSizeText.DEFAULT_WARNING_TEXT, false, tokenMap);
    return (_jsx(_Fragment, { children: 
        // If there are no meal sizes, return the no meal size text.
        !MealSizes || MealSizes.length === 0 || mealSizesToRender.length === 0 ? (_jsx(Typography, Object.assign({ variant: "body1", align: "center" }, { children: tokenReplace(MealSizeText.NO_MEAL_SIZES_TO_DISPLAY, false, tokenMap) }))) : (_jsx(CardLayout, Object.assign({}, mealSizeCardLayoutSettings, { cardsToRender: mealSizesToRender.map((mealSize) => {
                const selected = storeCartMealSize ? storeCartMealSize.RecipeSizeId === mealSize.RecipeSizeId : false;
                {
                    return (_jsx(ToggleCard, { itemDisplayMode: MealSizeDisplayMode, 
                        // TODO: Images are not yet implemented.
                        // image={ShowImage && `${imageBaseUrl}${mealSize.defaultImage}`}
                        onClick: handleMealSizeChange(mealSize.RecipeSizeId, mealSizeChangeWarningTitle, mealSizeChangeWarningTextDefault), selected: selected, title: mealSize.Size, 
                        // TODO: Description text is not yet implemented.
                        // description={showDescription && mealSize.description}
                        descriptionLines: CardDescriptionLines, 
                        // TODO: Replace false with showDescription once description is implemented
                        showDescription: false }, mealSize.RecipeSizeId));
                }
            }) }))) }));
};
